import * as React from 'react'
import { IJsonResponse } from '../../../core/JsonApiSerializer'
import { adminService } from '../../../core/services'
import { EditTable } from '../../organisms'
import AdminLayoutIndex from './_layouts'
import I18n from '../../../core/i18n'

interface IProps {
  contacts: {
    contacts: IJsonResponse
  }
}

const COLUMNS = [
  {
    name: I18n.t('generic.id'),
    field: 'id',
  },
  {
    name: I18n.t('generic.name'),
    field: 'name',
  },
  {
    name: I18n.t('generic.email'),
    field: 'email',
  },
  {
    name: I18n.t('contact.subject'),
    field: 'subject',
  },
  {
    name: I18n.t('contact.body'),
    field: 'body',
  },
  {
    name: I18n.t('generic.status'),
    field: 'status',
  },
  {
    name: I18n.t('generic.note'),
    field: 'note',
  },
  {
    name: I18n.t('generic.user_id'),
    field: 'user_id',
  },
  {
    name: I18n.t('generic.created_at'),
    field: 'created_at',
  },
  {
    name: I18n.t('generic.updated_at'),
    field: 'updated_at',
  },
]

const Index: React.FC<IProps> = props => {
  const { data } = adminService.getDataFromJson(props.contacts.contacts)

  return (
    <AdminLayoutIndex
      model="contact"
      title={I18n.t('generic.contact')}
      main={
        <EditTable
          editable={false}
          columns={COLUMNS}
          records={data}
          pagination={props.contacts.contacts.meta}
        />
      }
    />
  )
}

export default Index
